import React, { FC } from 'react';
import { Row, Spacer, Text } from '@components/1-atoms';
import { TextView } from '@components/2-molecules';
import styled from '@emotion/native';

const Container = styled.View`
  padding: 9px;
`;

interface DefaultValue {
  name?: string;
  addressLine1?: string;
  addressLine2?: string;
  email?: string;
  phone?: string;
}

interface Props {
  defaultValue?: DefaultValue;
}

const ContactView: FC<Props> = ({ defaultValue }) => {
    
  // Don't render anything if defaultValue is not provided
  if (!defaultValue) {
    return null;
  }

  const { name, addressLine1, addressLine2, email, phone } = defaultValue;

  return (
    <Container>
      {name && (
        <Row>
          <Text>{name}</Text>
        </Row>
      )}
      {(name && (addressLine1 || addressLine2)) && <Spacer h={0.9} />}

      {addressLine1 && (
        <Row>
          <Text small>{addressLine1}</Text>
        </Row>
      )}
      {addressLine2 && (
        <Row>
          <Text small>{addressLine2}</Text>
        </Row>
      )}

      {(addressLine1 || addressLine2) && (email || phone) && <Spacer h={0.6} />}

      {(email || phone) && (
        <Row>
          {email && <TextView mini label={"Email"} defaultValue={email} />}
          {phone && <TextView mini label={"Mobile"} defaultValue={phone} />}
        </Row>
      )}
    </Container>
  );
};

export default ContactView;